// useColorPalette.js
// Returns the guest favorite color palette from Firestore (config/colorPalette),
// falling back to the hardcoded defaults in flashDesigns.js. Editable from
// /help → Designs tab → "Guest Favorite Colors" section.

import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { COLOR_OPTIONS } from "../flashDesigns";

export default function useColorPalette() {
  const [colors, setColors] = useState(COLOR_OPTIONS);

  useEffect(() => {
    return onSnapshot(
      doc(db, "config", "colorPalette"),
      (snap) => {
        if (snap.exists() && Array.isArray(snap.data().colors)) {
          setColors(snap.data().colors);
        }
      },
      () => {} // fallback silently to defaults
    );
  }, []);

  return colors;
}
